import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HtmlComponent} from './html.component';

@NgModule({
    declarations: [
        HtmlComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        HtmlComponent
    ],
    providers: []
})

export class BlitzBasicScriptHtmlModule {
}
